import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./MergingListUIHelpers";

const MergingListUIContext = createContext();

export function useMergingListUIContext() {
  return useContext(MergingListUIContext);
}

export const MergingListUIConsumer = MergingListUIContext.Consumer;

export function MergingListUIProvider({ mergingListUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initMergingList = {
    name: "",
    access: [],
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initMergingList,
    newMergingListButtonClick: mergingListUIEvents.newMergingListButtonClick,
    openEditMergingListPage: mergingListUIEvents.openEditMergingListPage,
  };

  return (
    <MergingListUIContext.Provider value={value}>
      {children}
    </MergingListUIContext.Provider>
  );
}
